'use strict';

var _compose = require('./helpers/compose');

var _compose2 = _interopRequireDefault(_compose);

var _mongoose = require('mongoose');

var _mongoose2 = _interopRequireDefault(_mongoose);

var _isVisible = require('./isVisible');

var _isVisible2 = _interopRequireDefault(_isVisible);

var _enums = require('../enums');

var _enums2 = _interopRequireDefault(_enums);

var _mongooseOptions = require('./mongooseOptions');

var _mongooseOptions2 = _interopRequireDefault(_mongooseOptions);

var _price = require('../price');

var _price2 = _interopRequireDefault(_price);

var _AddOn = require('../virtuals/AddOn');

var _AddOn2 = _interopRequireDefault(_AddOn);

var _pathEquals = require('./plugins/pathEquals');

var _pathEquals2 = _interopRequireDefault(_pathEquals);

var _pathIn = require('./plugins/pathIn');

var _pathIn2 = _interopRequireDefault(_pathIn);

var _arrayDeleted = require('./plugins/arrayDeleted');

var _arrayDeleted2 = _interopRequireDefault(_arrayDeleted);

var _lodash = require('lodash');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Constants


// Plugins
var NEEDS_QUANTITY_PRICE_TYPES = _AddOn2.default.constants.NEEDS_QUANTITY_PRICE_TYPES;

// Lodash


var schema = new _mongoose2.default.Schema({
  // Is this add-on nested in a BookingRequest?
  isForBooking: { type: Boolean },
  isCustom: { type: Boolean, default: false },
  item: { type: String, required: _isVisible2.default },
  priceInCents: {
    type: Number,
    validate: [function (value) {
      if (this.isDeleted) {
        return true;
      }
      if (this.schemaType !== 'AddOn') {
        return true;
      }
      if (this.priceType === 'FREE') {
        return !value;
      }
      return !!value;
    }, 'priceInCents is required']
  },
  taxType: { type: String, enum: (0, _lodash.keys)(_enums2.default.taxTypes), default: 'NON_FOOD_AND_BEVERAGE' },
  priceType: { type: String, enum: (0, _lodash.keys)(_enums2.default.priceType), default: 'FREE', set: adjustPrice },
  numGuests: {
    type: Number,
    min: 1,
    required: [_compose2.default.and([(0, _pathIn2.default)('priceType', NEEDS_QUANTITY_PRICE_TYPES), (0, _pathEquals2.default)('isForBooking', true)]), 'If an add-on is by quantity and for a booking request, it must have a quantity specified']
  }
}, _mongooseOptions2.default);

schema.plugin(_arrayDeleted2.default);

/**
 * Get the total amount the guest needs to pay for this AddOn in cents.
 *
 * @return {Number} price in cents
 */

schema.virtual('totalCostCents').get(function () {
  return _AddOn2.default.totalCostCents(this);
});

/**
 * Total cost in dollars
 *
 * @return {String} price
 */

schema.virtual('totalCostDollars').get(function () {
  return _price2.default.convertToDollarsAndRound(this.totalCostCents);
});

schema.virtual('price').get(function () {
  if (!this.priceInCents) {
    return null;
  }
  return (this.priceInCents / 100).toFixed(2);
}).set(function (value) {
  this.priceInCents = value ? (parseFloat(value) * 100).toFixed(0) : null;
});

function adjustPrice(priceType) {
  if (priceType === 'FREE') {
    this.priceInCents = null;
  }
  return priceType;
}

schema.virtual('schemaType').get(function () {
  return 'AddOn';
});

module.exports = schema;